module.exports = __webpack_public_path__ + "img/20.ed43af54.jpg";